import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { ClaimsService, MenuContentItem } from '@frontend/vanilla/core';
import { ImageComponent } from '@frontend/vanilla/shared/image';

/**
 * NOTE: not used in v2
 */
@Component({
    imports: [ImageComponent],
    selector: 'lh-am-coral-cashback-level',
    templateUrl: 'coral-cashback-level.html',
    styleUrls: ['../../../../../../themepark/themes/whitelabel/components/coral-cashback/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CoralCashbackLevelComponent implements OnInit {
    private claimService = inject(ClaimsService);

    @Input() item: MenuContentItem;
    model: MenuContentItem | undefined;

    ngOnInit() {
        const vipLevel = this.claimService.get('vipLevel');
        this.model = this.item.children.find((item: MenuContentItem) => item.name.toLowerCase() === 'level_' + (vipLevel || 'nonvip').toLowerCase());
    }
}
